export const isAccessValid = () => {
    const validated = localStorage.getItem('accessValidated');
    const expiredAt = localStorage.getItem('accessExpiredAt');
    
    if (!validated || !expiredAt) {
        return false;
    }
    
    const now = new Date();
    const expiryDate = new Date(expiredAt);
    
    return now < expiryDate;
};

export const getRemainingTime = () => {
    const expiredAt = localStorage.getItem('accessExpiredAt');
    if (!expiredAt) return 0;
    
    const now = new Date();
    const expiryDate = new Date(expiredAt);
    return expiryDate - now;
};

export const clearAccess = () => {
    localStorage.removeItem('accessValidated');
    localStorage.removeItem('accessExpiredAt');
};